require('./compliance-services.module.js');
require('./compliance-services.route.js');

require('./annual_events');
require('./articles');
require('./calendar');
require('./categories');
require('./check_lists');
require('./checklist_forms');
require('./checklist_submissions');
require('./cms');
require('./components');
require('./consultation');
require('./consumer_complaints');
require('./consumer_complaint_searches');
require('./enhancement');
require('./dashboard');
require('./events');
require('./helpful_resources');
require('./knowledgebase');
require('./layouts');
require('./manuals');
require('./messages');
require('./news');
require('./policy_templates');
require('./quick_guides');
require('./search');
require('./services');
require('./staff_biographies');
require('./topics');
require('./vendor_due_diligence_documents');
require('./webinars');
require('./workqueue');
require('./workqueue_reporting');
require('./consultation_reporting');
